// import React, { useState, useRef, useEffect } from 'react';
// import { Table, Spin } from 'antd';
// import { Title2 } from 'components/Typography';

// const LeaveTable = ({
//   setDeleteLeaveModal, handleEditLeave, selectedRowKeys, setIdToDelete, user, 
//   setMultiLeaveDeleteModal, setActionObject, setReqTitleModal, toggleConfirmationModal, 
//   leaveOrAttendanceRequestActions, fromWhere, setSelectedLeaveRow, setIsEdit, leaveDetails_V3, onRow ,columns
// }) => {
//   const [loading, setLoading] = useState(false);
//   console.log("leavedetailshistory",leaveDetails_V3)
//   const [visibleData, setVisibleData] = useState([]); // Load initial 5 items
//   const containerRef = useRef(null);

//   useEffect(() => {
//     setVisibleData(leaveDetails_V3?.leaveHistory?.slice(0,5))
// }, []);

//   useEffect(() => {
//     const container = containerRef.current;

//     const handleScroll = (e) => {
//       const { scrollTop, clientHeight, scrollHeight } = container;
//       const isScrollingDown = e.deltaY > 0;

//       if (isScrollingDown && scrollTop + clientHeight >= scrollHeight - 50 && !loading) {
//         // Load more items when scrolling down
//         loadMoreData();
//       }
//     };

//     container.addEventListener('wheel', handleScroll, { passive: true });

//     return () => {
//       container.removeEventListener('wheel', handleScroll);
//     };
//   }, [loading, visibleData]);
//   useEffect(() => {
//     setLoading(true);
//     setTimeout(() => {
//       const newData = leaveDetails_V3?.leaveHistory?.slice(0,visibleData.length);
//       setVisibleData(prevData => [...newData]);
//       setLoading(false);
//     }, 1000);
//   }, [leaveDetails_V3]);
  
//   const loadMoreData = () => {
//     if (loading) return;

//     setLoading(true);
//     setTimeout(() => {
//       const newData = leaveDetails_V3?.leaveHistory.slice(visibleData.length, visibleData.length + 5);
//       setVisibleData(prevData => [...prevData, ...newData]);
//       setLoading(false);
//     }, 1000);
//   };

//   const disablePrevDateRows = (record) => {
//     const startDate = moment(record?.startDate, 'YYYY-MM-DD');
//     const currentDate = moment().startOf('day');
//     return startDate.isBefore(currentDate);
//   };

// //   const rowSelection = {
// //     type: "checkbox",
// //     selectedRowKeys: selectedRowKeys,
// //     getCheckboxProps: (record) => ({ disabled: disablePrevDateRows(record) }),
// //     onChange: (selectedRowKeys, selections) => {
// //       setSelectedRowKeys([...selectedRowKeys]);
// //     },
// //   };

//   return (
//     <div
//       ref={containerRef}
//       style={{ maxHeight: '70vh', overflowY: 'auto', position: 'relative' }}
//     >
//       <Table
//         columns={columns}
//         dataSource={visibleData}
//         rowKey={record => record.id}
//         pagination={false} // Disable pagination
//         onRow={onRow}
//         locale={{
//           emptyText: (
//             <div style={{ textAlign: 'center' }}>
//               <img
//                 width={200}
//                 style={{ marginBottom: "20px" }}
//                 src={require("Assets/test/no-subjects.svg").default}
//                 alt=""
//               />
//               <div style={{ color: "#191919", fontSize: 16, fontWeight: 500 }}>No attendance request!</div>
//               <div style={{ color: "#636363" }}>No data available to show</div>
//             </div>
//           ),
//         }}
//       />
//       {loading && (
//         <div style={{ textAlign: 'center', padding: '12px' }}>
//           <Spin />
//         </div>
//       )}
//     </div>
//   );
// };

// export default LeaveTable;

// import React, { useState, useRef, useEffect } from 'react';
// import { Table, Spin } from 'antd';
// import { Title2 } from 'components/Typography';
// import moment from 'moment'; // Import moment for disablePrevDateRows

// const LeaveTable = ({
//   setDeleteLeaveModal, handleEditLeave, selectedRowKeys, setIdToDelete, user, 
//   setMultiLeaveDeleteModal, setActionObject, setReqTitleModal, toggleConfirmationModal, 
//   leaveOrAttendanceRequestActions, fromWhere, setSelectedLeaveRow, setIsEdit, leaveDetails_V3, onRow, columns
// }) => {
//   const [loading, setLoading] = useState(false);
//   const [visibleData, setVisibleData] = useState([]);
//   const containerRef = useRef(null);
//   const [hasMoreData, setHasMoreData] = useState(true);

//   // Get leave history safely with fallback to empty array
//   const leaveHistory = leaveDetails_V3?.leaveHistory || [];

//   useEffect(() => {
//     // Load initial 5 items
//     const initialData = leaveHistory.slice(0, 5);
//     setVisibleData(initialData);
//     setHasMoreData(leaveHistory.length > 5);
//   }, [leaveDetails_V3]); // Re-run when leaveDetails_V3 changes

//   useEffect(() => {
//     const container = containerRef.current;
//     if (!container) return;

//     const handleScroll = (e) => {
//       const { scrollTop, clientHeight, scrollHeight } = container;
//       const isScrollingDown = e.deltaY > 0;

//       if (isScrollingDown && scrollTop + clientHeight >= scrollHeight - 50 && !loading && hasMoreData) {
//         loadMoreData();
//       }
//     };

//     container.addEventListener('wheel', handleScroll, { passive: true });

//     return () => {
//       container.removeEventListener('wheel', handleScroll);
//     };
//   }, [loading, visibleData, hasMoreData]);

//   const loadMoreData = () => {
//     if (loading || !hasMoreData) return;

//     setLoading(true);
//     setTimeout(() => {
//       const currentLength = visibleData.length;
//       const newData = leaveHistory.slice(currentLength, currentLength + 5);
      
//       if (newData && newData.length > 0) {
//         setVisibleData(prevData => [...prevData, ...newData]);
//         // Check if we've loaded all data
//         if (currentLength + newData.length >= leaveHistory.length) {
//           setHasMoreData(false);
//         }
//       } else {
//         setHasMoreData(false);
//       }
//       setLoading(false);
//     }, 500); // Reduced timeout for better UX
//   };

//   const disablePrevDateRows = (record) => {
//     if (!record?.startDate) return false;
//     const startDate = moment(record.startDate, 'YYYY-MM-DD');
//     const currentDate = moment().startOf('day');
//     return startDate.isBefore(currentDate);
//   };

//   const rowSelection = {
//     type: "checkbox",
//     selectedRowKeys: selectedRowKeys,
//     getCheckboxProps: (record) => ({ disabled: disablePrevDateRows(record) }),
//     onChange: (selectedRowKeys, selections) => {
//       // This should be handled by parent component
//       if (setSelectedRowKeys) {
//         setSelectedRowKeys([...selectedRowKeys]);
//       }
//     },
//   };

//   return (
//     <div
//       ref={containerRef}
//       style={{ maxHeight: '70vh', overflowY: 'auto', position: 'relative' }}
//     >
//       <Table
//         columns={columns}
//         dataSource={visibleData}
//         rowKey={record => record?.id || Math.random().toString()}
//         pagination={false}
//         onRow={onRow}
//         rowSelection={rowSelection}
//         locale={{
//           emptyText: (
//             <div style={{ textAlign: 'center' }}>
//               <img
//                 width={200}
//                 style={{ marginBottom: "20px" }}
//                 src={require("Assets/test/no-subjects.svg").default}
//                 alt="No data"
//               />
//               <div style={{ color: "#191919", fontSize: 16, fontWeight: 500 }}>No attendance request!</div>
//               <div style={{ color: "#636363" }}>No data available to show</div>
//             </div>
//           ),
//         }}
//       />
//       {loading && (
//         <div style={{ textAlign: 'center', padding: '12px' }}>
//           <Spin />
//         </div>
//       )}
//       {!hasMoreData && visibleData.length > 0 && (
//         <div style={{ textAlign: 'center', padding: '12px', color: '#636363' }}>
//           No more data to load
//         </div>
//       )}
//     </div>
//   );
// };

// export default LeaveTable;

import React, { useState, useRef, useEffect, useMemo, useCallback } from 'react';
import { Table, Spin } from 'antd';
import { Title2 } from 'components/Typography';
import moment from 'moment';

const PAGE_SIZE = 5;

const getRecordKey = (record, index) => {
    return record?.id ?? record?.commonId ?? record?.fileKey ?? `${record?.startDate}_${record?.endDate}_${record?.leaveType}_${record?.subType}_${index}`;
};

const LeaveTable = ({
    setDeleteLeaveModal,
    handleEditLeave,
    selectedRowKeys,
    setIdToDelete,
    user,
    setMultiLeaveDeleteModal,
    setActionObject,
    setReqTitleModal,
    toggleConfirmationModal,
    leaveOrAttendanceRequestActions,
    fromWhere,
    setSelectedLeaveRow,
    setIsEdit,
    leaveDetails_V3,
    onRow,
    columns
}) => {
    const [loading, setLoading] = useState(false);
    const [visibleData, setVisibleData] = useState([]);
    const [hasMoreData, setHasMoreData] = useState(false);

    const containerRef = useRef(null);
    const isFetchingRef = useRef(false);
    const loadedCountRef = useRef(0);

    // Get leave history safely and deduplicate by unique id if present
    const rawLeaveHistory = leaveDetails_V3?.leaveHistory || [];
    const leaveHistory = useMemo(() => {
        const seen = new Set();
        return rawLeaveHistory.filter((item, index) => {
            const key = item?.id ?? item?.commonId ?? item?.fileKey;
            if (key) {
                if (seen.has(key)) return false;
                seen.add(key);
            }
            return true;
        });
    }, [rawLeaveHistory]);

    useEffect(() => {
        const initialCount = Math.min(leaveHistory.length, PAGE_SIZE);
        const initialData = leaveHistory.slice(0, initialCount);
        loadedCountRef.current = initialCount;
        setVisibleData(initialData);
        setHasMoreData(leaveHistory.length > initialCount);
        isFetchingRef.current = false;
        setLoading(false);
    }, [leaveHistory]);

    const loadMoreData = useCallback(() => {
        if (isFetchingRef.current) return;
        if (loadedCountRef.current >= leaveHistory.length) {
            setHasMoreData(false);
            return;
        }

        isFetchingRef.current = true;
        setLoading(true);

        setTimeout(() => {
            const currentCount = loadedCountRef.current;
            if (currentCount >= leaveHistory.length) {
                setHasMoreData(false);
                setLoading(false);
                isFetchingRef.current = false;
                return;
            }

            const nextCount = currentCount + PAGE_SIZE;
            const newChunk = leaveHistory.slice(currentCount, nextCount);

            if (newChunk && newChunk.length > 0) {
                loadedCountRef.current = currentCount + newChunk.length;
                setVisibleData(prevData => {
                    const seenKeys = new Set(prevData.map((item, idx) => getRecordKey(item, idx)));
                    const uniqueNew = newChunk.filter((item, idx) => {
                        const key = getRecordKey(item, currentCount + idx);
                        if (seenKeys.has(key)) return false;
                        seenKeys.add(key);
                        return true;
                    });
                    return [...prevData, ...uniqueNew];
                });

                if (loadedCountRef.current >= leaveHistory.length) {
                    setHasMoreData(false);
                }
            } else {
                setHasMoreData(false);
            }

            setLoading(false);
            isFetchingRef.current = false;
        }, 300);
    }, [leaveHistory]);

    useEffect(() => {
        const root = containerRef.current;
        if (!root) return;

        const tableBody = root.querySelector('.ant-table-body') || root;

        const handleTableScroll = () => {
            if (!tableBody) return;
            const { scrollTop, clientHeight, scrollHeight } = tableBody;
            if (scrollTop + clientHeight >= scrollHeight - 30) {
                loadMoreData();
            }
        };

        const handleWheel = (e) => {
            if (e.deltaY <= 0) return;
            if (isFetchingRef.current) return;
            if (loadedCountRef.current >= leaveHistory.length) return;

            if (tableBody) {
                const { scrollTop, clientHeight, scrollHeight } = tableBody;
                const hasScrollbar = scrollHeight > clientHeight;
                if (hasScrollbar && scrollTop + clientHeight < scrollHeight - 30) {
                    return;
                }
            }
            loadMoreData();
        };

        tableBody.addEventListener('scroll', handleTableScroll, { passive: true });
        root.addEventListener('wheel', handleWheel, { passive: true });

        return () => {
            tableBody.removeEventListener('scroll', handleTableScroll);
            root.removeEventListener('wheel', handleWheel);
        };
    }, [loadMoreData, leaveHistory]);

    const disablePrevDateRows = (record) => {
        if (!record?.startDate) return false;
        const startDate = moment(record.startDate, 'YYYY-MM-DD');
        const currentDate = moment().startOf('day');
        return startDate.isBefore(currentDate);
    };

    const rowSelection = {
        type: "checkbox",
        selectedRowKeys: selectedRowKeys,
        getCheckboxProps: (record) => ({ disabled: disablePrevDateRows(record) }),
        onChange: (selectedRowKeys, selections) => {
            if (setSelectedRowKeys) {
                setSelectedRowKeys([...selectedRowKeys]);
            }
        },
    };

    const hasData = visibleData && visibleData.length > 0;
    const getRowClassName = (record, index) => {
        const isLastRow = index === visibleData.length - 1;
        return isLastRow ? 'last-row-no-border' : '';
    };

    return (
        <div
            ref={containerRef}
            style={{ position: 'relative' }}
        >
          {hasData ? (
                <>
                    <Table 
                        className="leave-req-table"
                        columns={columns}
                        dataSource={visibleData}
                        rowKey={(record, index) => getRecordKey(record, index)}
                        pagination={false}
                        onRow={(record, index) => ({
                            ...onRow?.(record, index),
                            className: getRowClassName(record, index)
                        })}
                        scroll={{ y: '60vh' }}
                        sticky
                        components={{
                            body: {
                                row: ({ children, ...props }) => (
                                    <tr {...props} className={props.className}>
                                        {children}
                                    </tr>
                                )
                            }
                        }}
                    />
                    {loading && (
                        <div style={{ textAlign: 'center', padding: '12px' }}>
                            <Spin />
                        </div>
                    )}
                </>
            ) : (
                <div 
                    style={{
                        padding: '48px 0',
                        textAlign: 'center',
                        background: '#fff',
                        borderRadius: 8,
                    }}
                >
                    <img
                        width={200}
                        style={{ marginBottom: "20px" }}
                        src={require("Assets/test/no-subjects.svg").default}
                        alt="No data"
                    />
                    <div className='color-black text-md bold'>No leave requests</div>
                    <div className='simgrey'>User has not applied for any leaves yet</div>
                </div>
            )}
        </div>
    );
};

export default LeaveTable;